module.exports = __webpack_public_path__ + "img/tn.91251c44.svg";